module.exports = __webpack_public_path__ + "static/media/slider2.da32b87e.jpg";